import { createSelector } from 'reselect'

import { singleCardSelector } from './cardsFirstOrder'
import { allBeatsSelector } from './beatsFirstOrder'
import { allLinesSelector } from './linesFirstOrder'
import { emptyCard } from '../helpers/cards'
import { currentTimelineSelector } from './secondOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').Beat} Beat
 * @typedef {import('../index').Card} Card
 */

const beatIdSelector = (_state, beatId) => beatId
/**
 * @type {function(PlottrState, number): (Beat | Null)}
 */
export const singleBeatInCurrentBookSelector = createSelector(
  currentTimelineSelector,
  allBeatsSelector,
  beatIdSelector,
  (bookId, beats, beatId) => {
    return beats[bookId].index[beatId] ?? null
  }
)

/**
 * @param {PlottrState} _state
 * @param {number} _cardId
 * @param {number} beatId
 * @return {number}
 */
const beatIdThirdSelector = (_state, _cardId, beatId) => beatId

/**
 * @type {function(PlottrState, number, number): Card}
 */
export const singleCardOrDefaultSelector = createSelector(
  allLinesSelector,
  singleCardSelector,
  currentTimelineSelector,
  allBeatsSelector,
  beatIdThirdSelector,
  (lines, card, bookId, beats, beatId) => {
    const beat = beats[bookId].index[beatId]
    return card || emptyCard(0, beat, lines[0])
  }
)
